export const getRedirectUrl = (isDevelopment: boolean) => {
  if (isDevelopment) return 'https://abstage.tech'
  return window?.location?.origin || ''
}
